import styled from "styled-components";

export const Graph = styled.div`
display: flex;
flex-direction: column;
gap: 1rem;
align-items: center;
justify-content: center;
   img{
        width: 40px;
        margin-top: -5px;
        @media (max-width: 770px) {
            width: 25px;
        }
    }
.graph{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 1rem;
    span{
font-size: 32px;
font-weight: 400;
  @media (max-width: 770px) {
            font-size: 22px;
        }
    }
    h1{
font-size: 22px;
font-weight: 400;
  @media (max-width: 770px) {
            font-size: 16px;
        }
    }
  
 
}
`